import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { SeoMetadataService } from '../../_ecomservices/seo-metadata.service';
import { NotificationService } from 'src/app/_services/notification.service';
import { LoadingService } from 'src/app/_services/loading.service';



@Component({
  selector: 'app-seo-metadata',
  templateUrl: './seo-metadata.component.html',
  styleUrls: ['./seo-metadata.component.css']
})
export class SeoMetadataComponent implements OnInit {

  @Input() seo_metadata: {
    // id: number; 
    entity_type: string;
    entity_id: number;
    meta_title: string;
    meta_description: string;
    meta_keywords: string;
    canonical_url: string;
    og_title: string; og_description: string; og_image: string; og_url: string; og_type: string;
  }

  seo_meta_form = new FormGroup({
    // id: new FormControl(null),
    entity_type: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    entity_id: new FormControl('', [Validators.required]),
    meta_title: new FormControl(''),
    meta_description: new FormControl(''),
    meta_keywords: new FormControl('', [Validators.required]),
    canonical_url: new FormControl(''),
    og_title: new FormControl(''),
    og_description: new FormControl(''),
    og_image: new FormControl(''),
    og_url: new FormControl(''),
    og_type: new FormControl(''),
  });

  constructor(private seoMetadataService: SeoMetadataService,
    private notificationService: NotificationService,
    private loading: LoadingService,
  ) { }

  ngOnInit() {
    console.log(this.seo_metadata);
    this.seo_meta_form.patchValue({
      // id: this.seo_metadata.id,
      entity_type: this.seo_metadata.entity_type,
      entity_id: this.seo_metadata.entity_id,
      meta_title: this.seo_metadata.meta_title,
      meta_description: this.seo_metadata.meta_description,
      meta_keywords: this.seo_metadata.meta_keywords,
      canonical_url: this.seo_metadata.canonical_url,
      og_title: this.seo_metadata.og_title,
      og_description: this.seo_metadata.og_description,
      og_image: this.seo_metadata.og_image,
      og_url: this.seo_metadata.og_url,
      og_type: this.seo_metadata.og_type,
    });
  }

  onSubmitSeoMetaForm() {
    if (this.seo_meta_form.valid) {
      this.loading
      console.log(this.seo_meta_form.value);
      // Call the service to save the form data
      this.seoMetadataService.updateSeoMetaData(this.seo_meta_form.value).subscribe(
        (data) => {
          console.log('SEO metadata updated successfully', data);
          if (data['status']) {
            this.notificationService.success('SEO metadata updated successfully');
          }
          else {
            this.notificationService.error('Failed to update SEO metadata');
          }

        },
        (error) => {
          console.error('Error updating SEO metadata', error);
        }
      );
    } else {
      console.log('Form is invalid');
    }
  }
}
